module.exports = __webpack_public_path__ + "static/media/tick-circle.fe8c15dd.svg";